import { ICompetitorsSnapshot } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import { ICompetitor } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Input } from 'core-components/library/inputs'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { getTwoLastSymbolsOfYear } from '../../../helpers/getTwoLastSymbolsOfYear'
import { LandscapeNote } from '../../styledComponents/notes/LandscapeNote'
import { NoteWrapper } from '../../styledComponents/notes/noteWrapper/NoteWrapper'
import { IColumn } from '../../styledComponents/styledTable/types'

import { PercentInput } from './percentInput/PercentInput'
import { PTNumberInput } from './ptNumberInput/PTNumberInput'

import styles from './Competitors.module.scss'

interface IProps {
  onCompetitorsChange: (
    index: number,
    cIndex: number,
    changedField: keyof ICompetitorsSnapshot
  ) => (value: string | number | null) => void
  currentFQuarter: number
  actualYear: number
}

const getCompetitorsThView = (currentFQuarter: number, actualYear: number) => {
  const quarterDisplay = (
    <>
      (FY'{getTwoLastSymbolsOfYear(actualYear)} Q{currentFQuarter})
    </>
  )

  return (
    <NoteWrapper noteContent={LandscapeNote} color={'dark'}>
      <div className={styles.note}>
        <Translation text={getFormedEltTranslation('competitors-table-category')} />
        <span>{quarterDisplay}</span>
      </div>
    </NoteWrapper>
  )
}

export const getCompetitorsColumns = ({
  currentFQuarter,
  onCompetitorsChange,
  actualYear,
}: IProps): IColumn<ICompetitor>[] => {
  return [
    {
      titleRenderFn: () => getCompetitorsThView(currentFQuarter, actualYear),
      field: 'CategoryName',
      renderComponent: ({ value }) => (
        <div className={styles.item}>
          <Translation text={value as string} />
        </div>
      ),
    },
    {
      title: getFormedEltTranslation('competitors-table-competitors'),
      field: 'Competitors',
      renderComponent: ({ value, index }) => {
        const items = value as ICompetitorsSnapshot[]
        return (
          <div>
            {items.map((el, cIndex) => (
              <Input
                key={cIndex}
                classes={{
                  root: styles.onlyBottomBorder,
                }}
                value={el.Name}
                onChange={onCompetitorsChange(index, cIndex, 'Name')}
              />
            ))}
          </div>
        )
      },
    },
    {
      title: getFormedEltTranslation('competitors-table-hpsow'),
      field: 'Competitors',
      width: 100,
      renderComponent: ({ value, index }) => {
        const items = value as ICompetitorsSnapshot[]
        return (
          <div>
            {items.map((el, cIndex) => (
              <PercentInput
                withoutSign
                key={cIndex}
                className={styles.onlyBottomBorder}
                value={el.HPSow}
                onChange={onCompetitorsChange(index, cIndex, 'HPSow')}
              />
            ))}
          </div>
        )
      },
    },
    {
      title: getFormedEltTranslation('competitors-table-yoy'),
      field: 'Competitors',
      width: 100,
      renderComponent: ({ value, index }) => {
        const items = value as ICompetitorsSnapshot[]
        return (
          <div>
            {items.map((el, cIndex) => {
              return (
                <PTNumberInput
                  key={cIndex}
                  classes={{
                    inputClasses: {
                      root: styles.onlyBottomBorder,
                    },
                  }}
                  value={el.YoY ? String(el.YoY) : ''}
                  onChange={onCompetitorsChange(index, cIndex, 'YoY')}
                  align={'right'}
                />
              )
            })}
          </div>
        )
      },
    },
  ]
}
